import { updatePermissions, getPermissions } from "./switchboard";
import { DEALS, SET_PACKAGE, DEAL_TAGS_BLACKLIST, DEAL_DEALS_BLACKLIST } from "../constants/products";
export var getPackage = function (_a) {
    var tenant = _a.tenant;
    return getPermissions(tenant, DEALS).then(function (productData) {
        return productData.packageId;
    });
};
export var updatePackage = function (query, packageId) {
    var tenant = query.tenant, team = query.team;
    var data = {
        tenantId: tenant.uuid,
        action: SET_PACKAGE,
        teamId: team === null || team === void 0 ? void 0 : team.uuid,
        values: [packageId]
    };
    return updatePermissions(data).then(function () {
        return service.getPackage(query);
    });
};
var getBlacklisted = function (_a, type) {
    var tenant = _a.tenant;
    if (type === void 0) { type = DEAL_TAGS_BLACKLIST; }
    return getPermissions(tenant, DEALS).then(function (productOptions) {
        return productOptions[type] || [];
    });
};
export var getBlacklistedTags = function (query) {
    return getBlacklisted(query, DEAL_TAGS_BLACKLIST);
};
export var getBlacklistedDeals = function (query) {
    return getBlacklisted(query, DEAL_DEALS_BLACKLIST);
};
var updateBlacklisted = function (query, blacklist, type) {
    if (type === void 0) { type = DEAL_TAGS_BLACKLIST; }
    var tenant = query.tenant, team = query.team;
    var data = {
        tenantId: tenant.uuid,
        action: type === DEAL_DEALS_BLACKLIST ? "BLACKLIST_DEAL_IDS" : "BLACKLIST_DEAL_TAGS",
        teamId: null,
        values: blacklist
    };
    return updatePermissions(data).then(function () {
        return service.getBlacklisted({ tenant: tenant, team: team }, type);
    });
};
export var updateBlacklistedTags = function (query, blacklist) {
    return updateBlacklisted(query, blacklist, DEAL_TAGS_BLACKLIST);
};
export var updateBlacklistedDeals = function (query, blacklist) {
    return updateBlacklisted(query, blacklist, DEAL_DEALS_BLACKLIST);
};
var service = {
    getPackage: getPackage,
    updatePackage: updatePackage,
    getBlacklisted: getBlacklisted,
    getBlacklistedTags: getBlacklistedTags,
    getBlacklistedDeals: getBlacklistedDeals,
    updateBlacklisted: updateBlacklisted,
    updateBlacklistedTags: updateBlacklistedTags,
    updateBlacklistedDeals: updateBlacklistedDeals
};
export default service;
